import {Inject, Injectable, Optional} from '@angular/core';
import {MAT_DATE_LOCALE, MatDateFormats} from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import moment from 'moment';

@Injectable()
export class CzechMomentDateAdapter extends MomentDateAdapter {
  constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
    super(dateLocale);
  }

  override parse(value: any, format: string | string[]): moment.Moment | null {
    if (typeof value === 'string' && value.includes('.')) {
      const parts = value.split('.');
      if (parts.length === 3) {
        const day = +parts[0];
        const month = +parts[1] - 1;
        const year = +parts[2];
        return moment(new Date(year, month, day));
      }
    }
    return super.parse(value, format);
  }

  override format(date: moment.Moment, displayFormat: string): string {
    if (displayFormat === 'dd.MM.yyyy') {
      const day = date.date();
      const month = date.month() + 1;
      const year = date.year();
      return `${day}.${month}.${year}`;
    }
    return super.format(date, displayFormat);
  }
}

export const CZECH_DATE_FORMATS: MatDateFormats = {
  parse: {dateInput: 'dd.MM.yyyy',},
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'dd.MM.yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
}

export const CZECH_MOMENT_LOCALE_SPECIFICATION = {
  months: [
    'Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen',
    'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec',
  ],
  monthsShort: [
    'Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer',
    'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro',
  ],
  longDateFormat: {
    LT: 'H:mm',
    LTS: 'H:mm:ss',
    L: 'dd.MM.YYYY',
    LL: 'd. MMMM YYYY',
    LLL: 'd. MMMM YYYY H:mm',
    LLLL: 'dddd, D. MMMM YYYY H:mm',
  },
}
